export default __webpack_public_path__ + "static/media/logo-default.81bc9984.png";